import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../common/Modal'
import Component from '../common/Component'

export default class BulkAvCalculatorEnqueueModal extends Component {
  static propTypes = {
    handleClose: PropTypes.func,
    handleEnqueue: PropTypes.func,
    isOpen: PropTypes.bool,
    disabled: PropTypes.bool
  }

  render() {
    if (!this.props.isOpen) { return null }

    return (
      <Modal
        className="bulk-av-calculator-enqueue-modal"
        isOpen={this.props.isOpen}
        handleClose={this.props.handleClose}
      >
        {this.props.children}
        <button
          className="select-button pure-button pure-input-1 pure-button-primary"
          type="button"
          disabled={this.props.disabled}
          onClick={this.props.handleEnqueue}
        >
          Enqueue AV Calculator
        </button>
      </Modal>
    )
  }
}
